import React, { Component } from 'react'
import axios from 'axios'
import Url from '../../services/k'
import swal from 'sweetalert'
export class Confirm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      loading: false,
    }
  }
  continue = (e) => {
    e.preventDefault()
    this.props.nextStep()
  }

  back = (e) => {
    e.preventDefault()
    this.props.prevStep()
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  handleSubmit = (e) => {
    e.preventDefault()
    const { workdetaildata } = this.props
    this.setState({ message: '', loading: true })

    let data = {
      parish: workdetaildata['parish'],
      dob: workdetaildata.dob,
      gender: workdetaildata.gender,
      password: workdetaildata.password,
      start_time: workdetaildata.start_time,
      completion_time: workdetaildata.completion_time,
      street_address: workdetaildata.street_address,
      reference_name: workdetaildata.reference_name,
      reference_phone: workdetaildata.reference_phone,
      emergency_contact_name: workdetaildata.emergency_contact_name,
      emergency_contact_phone: workdetaildata.emergency_contact_phone,
      workdays_selected: workdetaildata.workdays_selected,
      workhours_selected: workdetaildata.workhours_selected,
      vehicle_type: workdetaildata.vehicle_type,
      driving_period: workdetaildata.driving_period,
      license_number: workdetaildata.license_number,
      license_expiry: workdetaildata.license_expiry,
      courier_history: workdetaildata.courier_history,
      courier: workdetaildata.courier,
      has_involved_in_trafic_infraction:
        workdetaildata.has_involved_in_trafic_infraction,
      involved_in_crime: workdetaildata.involved_in_crime,
      has_smart_phone: workdetaildata.has_smart_phone,
      use_online_banking: workdetaildata.use_online_banking,
      has_bill_express_account: workdetaildata.has_bill_express_account,
      user_agree: workdetaildata.user_agree,
    }
    let rider_id = localStorage.getItem('rider_id')
    let url = Url.riderUpdateProfile(rider_id)

    axios
      .put(url, data, { 'Content-type': 'application/json' })
      .then(
        (resp) => {
          swal({
            title: 'Thank you for your submission.',
            text: 'Your information is now being reviewed internally for fitness.Within the next 24 hours we will send you an email detailing the next steps.',
            icon: 'success',
          }).then(() => {
            window.location.href = '/success'
          })
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()

          this.setState({
            loading: false,
            message: resMessage,
          })
        },
      )
      .catch((err) => {})
  }

  render() {
    const {
      workdetaildata: {
        parish,
        dob,
        gender,
        start_time,
        completion_time,
        street_address,
        reference_name,
        reference_phone,
        emergency_contact_name,
        emergency_contact_phone,
        workdays_selected,
        workhours_selected,
        vehicle_type,
        driving_period,
        license_number,
        license_expiry,
        courier_history,
        courier,
        has_involved_in_trafic_infraction,
        involved_in_crime,
        has_smart_phone,
        use_online_banking,
        has_bill_express_account,
        user_agree,
      },
    } = this.props
    const alldays = workdays_selected.map((days) => days.label)
    const allhours = workhours_selected.map((hours) => hours.label)
    return (
      <>
        <div className="main-wrapper inner--page rider-page">
          <section
            className="hero-banner inner-banner form-page"
            style={{ backgroundImage: `url('images/rider-banner.png')` }}
          >
            <div className="container">
              <div className="row pt-100">
                <div className="col-lg-8 offset-lg-2 col-md-8 offset-md-2">
                  <div className="partner-form">
                    <div className="heading-text border-bottom">
                      <h3>Become A Rider</h3>
                      <p>Check the information you provided </p>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <p>
                          <b>Start Time </b>
                          <br /> {start_time}
                        </p>
                      </div>
                      {/* <div className="col-lg-6">
                        <p>
                          <b>Completion time </b>
                          <br /> {completion_time}
                        </p>
                      </div> */}
                      {/* <div className="col-lg-6">
                        <p>
                          <b>Reference name </b>
                          <br /> {reference_name}
                        </p>
                      </div> */}
                      <div className="col-lg-6">
                        <p>
                          <b>Reference phone </b>
                          <br /> {reference_phone}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Emergency contact name </b>
                          <br /> {emergency_contact_name}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Emergency contact phone </b>
                          <br /> {emergency_contact_phone}
                        </p>
                      </div>

                      <div className="col-lg-6">
                        <p>
                          <b>Work Hours </b>
                          <br /> {allhours}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Parish </b>
                          <br /> {parish}
                        </p>
                      </div>
                      {/* <div className="col-lg-6">
                        <p>
                          <b>Involved in trafic infraction </b>
                          <br /> {has_involved_in_trafic_infraction}
                        </p>
                      </div> */}
                      <div className="col-lg-6">
                        <p>
                          <b>Involved in Crime </b>
                          <br /> {involved_in_crime}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Has smart phone </b>
                          <br /> {has_smart_phone}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Use online banking </b>
                          <br /> {use_online_banking}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Has bill express account </b>
                          <br /> {has_bill_express_account}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Street Address </b>
                          <br /> {street_address}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Date of Birth </b>
                          <br /> {dob}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Gender </b>
                          <br /> {gender}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Courier History </b>
                          <br /> {courier_history}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>License Number </b>
                          <br /> {license_number}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Expiry Date </b>
                          <br /> {license_expiry}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Type of Vehicle </b>
                          <br /> {vehicle_type}
                        </p>
                      </div>
                      <div className="col-lg-12">
                        <p>
                          <b>Has Courier License </b>
                          <br /> {courier}
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          <b>Work days </b>
                          <br />
                          {alldays}
                        </p>
                      </div>

                      <div className="col-lg-12">
                        {this.state.message && (
                          <span className="spinner-border spinner-borde-sm"></span>
                        )}
                        <p>
                          By clicking ‘Submit’, you agree to{' '}
                          <a href="#">RoadJockeyGeneral Terms and Conditions</a>{' '}
                          and acknowledge that you have read the{' '}
                          <a href="#">Privacy Policy.</a>
                        </p>
                      </div>
                      <div className="col-lg-12" onClick={this.handleSubmit}>
                        <button
                          className="primary-btn col-lg-12"
                          disabled={this.state.loading}
                        >
                          Confirm & Submit
                        </button>
                        {this.state.message && (
                          <div className="form-group">
                            <div className="alert alert-danger" role="alert">
                              {this.state.message}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

export default Confirm
